import React, { useEffect, useState } from "react";

import { StickyTable, Row, Cell } from "react-sticky-table";
import "./Statstable.css";

function createData(name, total, aiOrder, nonAiOrder) {
  return { name, total, aiOrder, nonAiOrder };
}

//NOTE: this component shows the all data of aiOrder,NonAiOrder and successful orders data
export default function Statustable({
  selectedCenterList,
  tableData,
  centerList,
  setCallDataTable,
}) {
  

  // NOTE:- This function sort the array's object data
  function dynamicSort(property) {
    var sortOrder = 1;

    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }

    return function (a, b) {
      if (sortOrder == -1) {
        return b[property].localeCompare(a[property]);
      } else {
        return a[property].localeCompare(b[property]);
      }
    };
  }


  


 

  return (
    <div style={{width:"100%"}}>
      <StickyTable>
        <Row style={{width:"100%"}}>
          <Cell className="table_header" >Center</Cell>
          <Cell className="table__cellStyle">Total #</Cell>
          <Cell className="table__cellStyle">AI Success Orders #</Cell>
          <Cell
            className="table__cellStyle"
            style={{
              border: "1px solid ##A7C941",
              borderRight: "2px solid #A7C941",
            }}
          >
            Operator Orders #
          </Cell>
        </Row>
        {Array.isArray(tableData) && tableData.map((item) => (
          <Row key={item.center_name}>
            <Cell
              style={{
                border: "1px solid #A7C941 ",
                borderLeft: "2px solid #A7C941",
              }}
            >
              {item.center_name}
            </Cell>
            <Cell style={{ border: "1px solid #A7C941 " }}>{item.TOTAL_ORDERS}</Cell>
            <Cell style={{ width: "100px", border: "1px solid #A7C941 " }}>
              {item.AI_ORDERS}
            </Cell>
            <Cell
              style={{
                border: "1px solid #A7C941 ",
                borderRight: "2px solid #A7C941",
              }}
            >
              {item.OPERATOR_ORDERS}
            </Cell>
          </Row>
        ))}
      </StickyTable>
    </div>
  );
}
